var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_444_54",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_444_54",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAACtUlEQVRoge2ZzU4UQRSFT6EzsxAeQBk2MjG60ji+ByBx5dq4UReK8AqiPgFrTfyBMCTGR1ASRV2ZENQVT8CMC0D8XFQTOkV3T1f/TMekT1KLqql77zmZO/dW1Ug1atSoUSWMz2agKWlO0oyk65Laks7l5PBb0q6kL5J6knrGmIOcPk8DmAd+Uj5+ADeLJH4GeD4C4i6eAWNFCKiC/DGW85KfHyHZd8Ak0Abeh9Zns5JvMpqcP0Y7FHsqtL6DLR6RSMqxOUkXM6kvFh3ZqheJJAGxRiVhBZs+U5JW0nKJ7QPAtqRLniQOJK1L2pCt67vBelu2b8wGIzYlYrBtjLnsZQHseebwKjA05YBpYM3T956nYMnD+R/gUQb/C8BR2iBlCvAmH4qxWLWA1Qi7FvAA2AQGwdgE7gOtiP3rVQnYx8l5bCP6lmDzFZh0bDqBr5ELeOXsbw0hHxbRcmzfZBWQ57C04czvSrqawu6apDtDfKVGHgFbzvy2h62793NWEkmNbFjeTRhjBqH9fUnjKeMOjDETIdtxSf1EosZEcs1/3s6Gv848M488Ai448+8etu7e81lJ5BHQdeYvPGxfOvMbOXhEI0U5fO3sbwUlMk0ZbTq2b7OW0TwC9oFpx2ZyiIi4RnZQhQCAtQi7JnAP+Aj0g/EhWDt1jAZ6aQKVJQBgwdv5SYyltEHKFHAEPM7gf5GSj9O+F5p1oJPCb4eUaRNC7IWm6Cvloezz4IbsUSN8pezKXidnJDU8/cZeKc8mGG3JX0BD0q1gFIlPcR8kNbJewSTyIPa0mpRCDdmWPzSvS8YvSVfiXqxjvwFjzKGkpbJYeeBhrud27CtxVXiSWz4wBjytgPwyRTyvh4TMYh9ay8YOkPpZ0/cvpoZOanlXtr6nvYXFYSDbL7YU9JDg91ejRo0a/wH+Ac32GJLYk4ruAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.37fe600481507259a0bd9308b408ad14.svg";
export { ForwardRef as ReactComponent };